
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {BlockedIPEventLogGetFilterResponse} from './BlockedIPEventLogGetFilterResponse';

/**
 * BlockedIPEventLogGetFilterRequest struct
 */
class BlockedIPEventLogGetFilterRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Date=} fromInclusive
   * @param {!Date=} toExclusive
   * @param {!number=} minEncounteredTimes
   * @constructor
   */
  constructor (parent = new Request(), fromInclusive = new Date(0), toExclusive = new Date(0), minEncounteredTimes = new UInt64(0, 0)) {
    super()
    super.copy(parent)
    this.FromInclusive = fromInclusive
    this.ToExclusive = toExclusive
    this.MinEncounteredTimes = minEncounteredTimes
  }

  /**
   * Copy struct (shallow copy)
   * @this {!BlockedIPEventLogGetFilterRequest}
   * @param {!BlockedIPEventLogGetFilterRequest} other Other struct
   * @returns {!BlockedIPEventLogGetFilterRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.FromInclusive != null) {
      if (other.FromInclusive instanceof Date) {
        this.FromInclusive = new Date(other.FromInclusive.getTime())
      } else {
        this.FromInclusive = new Date(Math.round(other.FromInclusive / 1000000))
      }
    } else {
      this.FromInclusive = null
    }
    if (other.ToExclusive != null) {
      if (other.ToExclusive instanceof Date) {
        this.ToExclusive = new Date(other.ToExclusive.getTime())
      } else {
        this.ToExclusive = new Date(Math.round(other.ToExclusive / 1000000))
      }
    } else {
      this.ToExclusive = null
    }
    if (other.MinEncounteredTimes != null) {
      this.MinEncounteredTimes = UInt64.fromNumber(other.MinEncounteredTimes)
    } else {
      this.MinEncounteredTimes = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!BlockedIPEventLogGetFilterRequest}
   * @returns {!BlockedIPEventLogGetFilterRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new BlockedIPEventLogGetFilterRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new BlockedIPEventLogGetFilterRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!BlockedIPEventLogGetFilterRequest}
   * @param {!BlockedIPEventLogGetFilterRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof BlockedIPEventLogGetFilterRequest)) {
      throw new TypeError('Instance of BlockedIPEventLogGetFilterRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!BlockedIPEventLogGetFilterRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      FromInclusive: ((this.FromInclusive != null) ? (this.FromInclusive.getTime() * 1000000) : null),
      ToExclusive: ((this.ToExclusive != null) ? (this.ToExclusive.getTime() * 1000000) : null),
      MinEncounteredTimes: ((this.MinEncounteredTimes != null) ? this.MinEncounteredTimes.toNumber() : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return BlockedIPEventLogGetFilterRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!BlockedIPEventLogGetFilterRequest} other Object value
   * @returns {!BlockedIPEventLogGetFilterRequest} Created struct
   */
  static fromObject (other) {
    return new BlockedIPEventLogGetFilterRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!BlockedIPEventLogGetFilterRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return BlockedIPEventLogGetFilterRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!BlockedIPEventLogGetFilterRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6559
  }
}

export { BlockedIPEventLogGetFilterRequest };

/**
 * Fast Binary Encoding BlockedIPEventLogGetFilterRequest field model
 */
class FieldModelBlockedIPEventLogGetFilterRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.FromInclusive = new fbe.FieldModelTimestamp(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.ToExclusive = new fbe.FieldModelTimestamp(buffer, this.FromInclusive.fbeOffset + this.FromInclusive.fbeSize)
    this.MinEncounteredTimes = new fbe.FieldModelUInt64(buffer, this.ToExclusive.fbeOffset + this.ToExclusive.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.FromInclusive.fbeSize + this.ToExclusive.fbeSize + this.MinEncounteredTimes.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.FromInclusive.fbeExtra + this.ToExclusive.fbeExtra + this.MinEncounteredTimes.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelBlockedIPEventLogGetFilterRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6559
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.FromInclusive.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FromInclusive.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FromInclusive.fbeSize

    if ((fbeCurrentSize + this.ToExclusive.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ToExclusive.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ToExclusive.fbeSize

    if ((fbeCurrentSize + this.MinEncounteredTimes.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MinEncounteredTimes.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MinEncounteredTimes.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @param {!BlockedIPEventLogGetFilterRequest} fbeValue Default value, defaults is new BlockedIPEventLogGetFilterRequest()
   * @returns {!BlockedIPEventLogGetFilterRequest} BlockedIPEventLogGetFilterRequest value
   */
  get (fbeValue = new BlockedIPEventLogGetFilterRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @param {!BlockedIPEventLogGetFilterRequest} fbeValue BlockedIPEventLogGetFilterRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.FromInclusive.fbeSize) <= fbeStructSize) {
      fbeValue.FromInclusive = this.FromInclusive.get()
    } else {
      fbeValue.FromInclusive = new Date(0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FromInclusive.fbeSize

    if ((fbeCurrentSize + this.ToExclusive.fbeSize) <= fbeStructSize) {
      fbeValue.ToExclusive = this.ToExclusive.get()
    } else {
      fbeValue.ToExclusive = new Date(0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ToExclusive.fbeSize

    if ((fbeCurrentSize + this.MinEncounteredTimes.fbeSize) <= fbeStructSize) {
      fbeValue.MinEncounteredTimes = this.MinEncounteredTimes.get()
    } else {
      fbeValue.MinEncounteredTimes = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MinEncounteredTimes.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @param {!BlockedIPEventLogGetFilterRequest} fbeValue BlockedIPEventLogGetFilterRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelBlockedIPEventLogGetFilterRequest}
   * @param {BlockedIPEventLogGetFilterRequest} fbeValue BlockedIPEventLogGetFilterRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.FromInclusive.set(fbeValue.FromInclusive)
    this.ToExclusive.set(fbeValue.ToExclusive)
    this.MinEncounteredTimes.set(fbeValue.MinEncounteredTimes)
  }
}

export { FieldModelBlockedIPEventLogGetFilterRequest };

/**
 * Fast Binary Encoding BlockedIPEventLogGetFilterRequest model
 */
class BlockedIPEventLogGetFilterRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelBlockedIPEventLogGetFilterRequest(this.buffer, 4)
  }

  /**
   * Get the BlockedIPEventLogGetFilterRequest model
   * @this {!BlockedIPEventLogGetFilterRequestModel}
   * @returns {!FieldModelBlockedIPEventLogGetFilterRequest} model BlockedIPEventLogGetFilterRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!BlockedIPEventLogGetFilterRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!BlockedIPEventLogGetFilterRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return BlockedIPEventLogGetFilterRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!BlockedIPEventLogGetFilterRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelBlockedIPEventLogGetFilterRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!BlockedIPEventLogGetFilterRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!BlockedIPEventLogGetFilterRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!BlockedIPEventLogGetFilterRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!BlockedIPEventLogGetFilterRequestModel}
   * @param {!BlockedIPEventLogGetFilterRequest} value BlockedIPEventLogGetFilterRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!BlockedIPEventLogGetFilterRequestModel}
   * @param {!BlockedIPEventLogGetFilterRequest} value BlockedIPEventLogGetFilterRequest value, defaults is new BlockedIPEventLogGetFilterRequest()
   * @return {!object} Deserialized BlockedIPEventLogGetFilterRequest value and its size
   */
  deserialize (value = new BlockedIPEventLogGetFilterRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new BlockedIPEventLogGetFilterRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new BlockedIPEventLogGetFilterRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!BlockedIPEventLogGetFilterRequestModel}
   * @param {!number} prev Previous BlockedIPEventLogGetFilterRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { BlockedIPEventLogGetFilterRequestModel };
BlockedIPEventLogGetFilterRequest.__has_response = true;
BlockedIPEventLogGetFilterRequest.__response_class = BlockedIPEventLogGetFilterResponse;
